/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Field_Group_Hint1Inputs */

const vi_guidevideo_field_group_hint1 = /** @type {(inputs: Guidevideo_Field_Group_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video cùng nhóm hiện chung một mục, vd "Cấu hình bán online".`)
};

/**

* @param {Guidevideo_Field_Group_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_field_group_hint1 = /** @type {((inputs?: Guidevideo_Field_Group_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Field_Group_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_field_group_hint1(inputs)
});
export { guidevideo_field_group_hint1 as "guideVideo_field_group_hint" }